import React from "react";
import Main from "../../../Components/Main";
import MainNav from "../../../Components/MainNav";
import Example from "../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const home = () => {
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <Main />
    </div>
  );
};

export default home;
